module.exports = __webpack_public_path__ + "static/media/motor3.c99627ff.jpg";